import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import NotificationSender from "../../components/notifications/NotificationSender";
import "./AcceptLink.css";
import ReactLoading from "react-loading";
import LinkMetrics from "./LinkMetrics";
import axios from "axios";
import config from "../../config";
import PropTypes from "prop-types";
import Popup from "../../components/popup/Popup";
import { useSession } from "../../context/SessionTracker";

export default function AcceptLink({
  setShowTopbar,
  setIsAccountBalanceModalOpen,
}) {
  const { linkCreatorUsername } = useParams();
  const [link, setLink] = useState({});
  const [linkUserData, setlinkUserData] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    user: currentUser,
    balance,
    dispatch,
    socket,
  } = useContext(AuthContext);
  const [isUserLink, setisUserLink] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [hasUserResponded, setHasUserResponded] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  // const [linkCreatorPhoto, setLinkCreatorPhoto] = useState();
  const [popupMessage, setPopupMessage] = useState("");
  const cloudfrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;
  const { trackEvent } = useSession();
  const popupStatus = async (message) => {
    setPopupMessage(message);
    setShowPopup(true);
  };

  useEffect(() => {
    const fetchLink = async () => {
      try {
        const res = await axios.post(
          `${config.apiUrl}/links/${linkCreatorUsername}`,
          {
            currentUser: currentUser || null,
          }
        );

        if (currentUser) {
          if (res.data.updatedLink.creatorUserId === currentUser._id) {
            // users cannot use their own link
            setisUserLink(true);
          }
        }
        setLink(res.data.updatedLink);
        const user = await axios.get(
          `${config.apiUrl}/api/users?userId=${res.data.updatedLink.creatorUserId}`
        );
        setlinkUserData(user.data);
      } catch (error) {
        // Handle both axios errors and our thrown errors
        let errorMessage = "";
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          errorMessage = error.response.data.message || "An error occurred";
        } else if (error.message) {
          // This is for the error we threw manually
          errorMessage = error.message;
        } else {
          // Any other unexpected errors
          errorMessage = "An unexpected error occurred";
        }
        setIsLoading(false);
        await popupStatus(errorMessage, "Close");
      } finally {
        setIsLoading(false);
      }
    };

    fetchLink();
  }, [linkCreatorUsername]);

  useEffect(() => {
    if (linkUserData) {
      // check if current user has responded to the link already
      const fetchLinkTransactions = async () => {
        try {
          const token = localStorage.getItem("token");
          const response = await axios.get(
            `${config.apiUrl}/api/user-respond`,
            {
              headers: {
                "x-auth-token": token,
              },
              params: {
                creatorUsername: linkUserData.username,
                linkResponderUsername: currentUser.username,
                linkId: link._id,
              },
            }
          );
          setIsLoading(false);
          setHasUserResponded(response.data.responded);
        } catch (error) {
          if (error.response && error.response.status === 500) {
            await popupStatus("An error occurred. Please try again later.");
          }
          setIsLoading(false);
        }
      };
      fetchLinkTransactions();
    }
  }, [linkUserData]);

  const acceptorgive = async () => {
    if (currentUser) {
      try {
        const token = localStorage.getItem("token");
        let receiverUserId = link.creatorUserId;
        let amount = link.details.amount;
        let type = link.details.type;
        let giveorreceive = link.details.giveorreceive;
        let linkOrWishlist = "link";
        let relatedPostId = link.id;
        let message = "interacted with your link";
        let ebItemPhoto = link.details.photo;
        let lastMessage;

        if (link.details.type === "currency") {
          if (giveorreceive === "give") {
            lastMessage = `$${amount}`;
          } else {
            lastMessage = `$${amount}`;
          }
        } else {
          if (giveorreceive === "give") {
            lastMessage = `${link.details.title}`;
          } else {
            lastMessage = `${link.details.title}`;
          }
        }

        // accepts link and update's both of the user's balances on the server
        // also creates a conversation between the two users if there is not one already
        // if conversation already exists, it updates the last message in the convo
        let res = await axios.put(
          `${config.apiUrl}/api/accept-link`,
          {
            lastMessage: lastMessage,
            linkCreatorUsername: linkCreatorUsername,
            linkResponderUsername: currentUser.username,
          },
          {
            headers: {
              "x-auth-token": token,
            },
          }
        );
        const conversationId = res.data.conversationId;
        const messageId = res.data.newMessage._id;
        const text = res.data.newMessage.text;
        await NotificationSender({
          socket,
          receiverUserId,
          amount,
          linkOrWishlist,
          giveorreceive,
          type,
          relatedPostId,
          message,
          ebItemPhoto,
          conversationId,
          messageId,
          text,
        });
        // update context so that the ui matches the server data
        const newBalance = balance - link.details.amount;
        dispatch({ type: "UPDATE_BALANCE", payload: newBalance });
        trackEvent("linkTransaction", link);
        navigate(`/messages/${res.data.conversationId}`);
      } catch (error) {
        await popupStatus(
          "An error occured when trying to use this link. Please try again later.",
          "Close"
        );
      }
    } else {
      console.log("nah");
    }
  };

  const goToAddFunds = () => {
    setIsAccountBalanceModalOpen(true);
    setShowTopbar(false);
  };

  const navigateToLogin = () => {
    navigate("/login", { state: { from: location } });
  };

  const navigateToRegister = () => {
    navigate("/register", { state: { from: location } });
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10rem",
          marginBottom: "20px",
        }}
      >
        <ReactLoading
          type={"balls"}
          color={"white"}
          height={"20%"}
          width={"20%"}
        />
      </div>
    );
  }

  return (
    <div className="accept-link-page-container">
      <Popup
        isPopupOpen={showPopup}
        message={popupMessage}
        button1Text="Close"
        button1Action={() => {
          setShowPopup(false);
          navigate("/");
        }}
      />

      {hasUserResponded || isUserLink ? (
        // When the user has responded or it's their own link
        hasUserResponded ? (
          <div className="own-link-container">
            <div className="own-link-pfp-container">
              <img
                className="profile-pic"
                src={
                  currentUser && currentUser.profilePicture
                    ? currentUser.profilePicture
                    : `${cloudfrontUrl}/static/no-profile-pic.webp`
                }
                alt="Profile"
              />
            </div>
            <h3 className="own-link-message">
              ... you can’t use this link more than once
            </h3>
          </div>
        ) : isUserLink ? (
          <LinkMetrics link={link} />
        ) : null
      ) : !hasUserResponded && link.details ? (
        // When there's a currentUser, they haven't responded, and we have link details
        <div className="link-details">
          {link.details.type === "currency" &&
          link.details.remainingQuantity > 0 ? (
            <>
              <div className="currency-square">${link.details.amount}</div>
              <div className="link-creator-info">
                <h3 className="link-title-and-details">
                  {link.creatorUsername}{" "}
                  {link.details.giveorreceive === "give"
                    ? "wants to give you"
                    : "would like"}{" "}
                  ${link.details.amount}
                </h3>
              </div>
            </>
          ) : link.details.type === "item" &&
            link.details.remainingQuantity > 0 &&
            !isLoading ? (
            <>
              <div className="image-description-amount">
                <div className="image-amount-container">
                  <img src={link.details.photo} alt="Item" />
                  <div className="link-right-side-container">
                    <h3 className="link-creator-and-title">
                      {link.creatorUsername}{" "}
                      {link.details.giveorreceive === "give"
                        ? "would like to give you"
                        : "would like to receive"}
                      : {link.details.title}
                    </h3>
                    <p className="amount">${link.details.amount}</p>
                  </div>
                </div>
                <div className="CTA-button-container">
                  {/* Additional buttons (if needed) can go here */}
                </div>
              </div>
            </>
          ) : (
            <div className="no-user-link-container">
              <p>Link is no longer available.</p>
            </div>
          )}
        </div>
      ) : (
        <div className="no-link-container">
          <p>Link not found</p>
        </div>
      )}

      {currentUser && !isUserLink && (
        <>
          <div className="accept-link-cta-container">
            {link.details &&
              link.details.giveorreceive === "give" &&
              !hasUserResponded && (
                <button
                  className="give-or-accept-button"
                  onClick={() => acceptorgive()}
                >
                  Accept
                </button>
              )}
            {link.details &&
              link.details.giveorreceive === "receive" &&
              (balance > link.details.amount ? (
                <button
                  className="give-or-accept-button"
                  onClick={() => acceptorgive()}
                >
                  Give
                </button>
              ) : (
                <button
                  className="give-or-accept-button"
                  onClick={goToAddFunds}
                >
                  Add Funds
                </button>
              ))}
          </div>
        </>
      )}

      {!currentUser && (
        <div className="no-user-link-container">
          <p className="no-user-link-message">
            Login or register to use this link{" "}
          </p>
          <div className="no-link-btn-container">
            <button className="login-button" onClick={() => navigateToLogin()}>
              Login
            </button>
            <button
              className="register-button"
              onClick={() => navigateToRegister()}
            >
              Register
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

AcceptLink.propTypes = {
  setShowTopbar: PropTypes.func,
  setIsAccountBalanceModalOpen: PropTypes.func,
};
